export default __webpack_public_path__ + "static/media/2.4d5b67b6.png";